import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { CloseUnreadTasksResponseSchema } from "@common/schemas/closeUnreadTasks.schema";
import {
    CloseIdPathParamsSchema,
    ClosePathParamsSchema,
    CloseQueryParamsSchema,
    CloseSchema,
    UpdateCloseBodySchema,
    UpdateCloseResponseSchema,
} from "../schemas/close.schema";

const c = initContract();

export const closeContract = c.router(
    {
        listCloses: {
            method: "GET",
            path: "/organizations/:organizationId",
            pathParams: ClosePathParamsSchema,
            query: CloseQueryParamsSchema,
            responses: {
                200: z.object({
                    closes: z.array(CloseSchema),
                }),
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        deleteClose: {
            method: "DELETE",
            path: "/organizations/:organizationId/:closeId",
            pathParams: ClosePathParamsSchema.merge(CloseIdPathParamsSchema),
            body: c.noBody(),
            responses: {
                200: z.object({ deletedTaskCount: z.number() }),
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        cancelClose: {
            method: "POST",
            path: "/organizations/:organizationId/:closeId/cancel",
            pathParams: ClosePathParamsSchema.merge(CloseIdPathParamsSchema),
            body: c.noBody(),
            responses: {
                200: CloseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        updateClose: {
            method: "PATCH",
            path: "/organizations/:organizationId/:closeId",
            pathParams: ClosePathParamsSchema.merge(CloseIdPathParamsSchema),
            body: UpdateCloseBodySchema,
            responses: {
                200: UpdateCloseResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        listCloseUnreadTasks: {
            method: "GET",
            path: "/organizations/:organizationId/:closeId/unread-tasks",
            pathParams: ClosePathParamsSchema.merge(CloseIdPathParamsSchema),
            responses: {
                200: CloseUnreadTasksResponseSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/closes",
    },
);
